// extracted by mini-css-extract-plugin
module.exports = {"input":"FormInput_input__Apl0e","label":"FormInput_label__LdJvQ"};